import { render } from "./Etalometro.vue?vue&type=template&id=0849e922"
import script from "./Etalometro.vue?vue&type=script&lang=js"
export * from "./Etalometro.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__